import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

const fetchAnnualData = async (year, vm = null) => {
  if (!year) {
    if (vm?.$toast) {
      vm.$toast({
        component: ToastificationContent,
        props: {
          title: 'Parâmetro inválido',
          text: 'O ano é obrigatório para a consulta',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          timeout: 5000,
        },
      })
    }
    return { labels: [], datasets: [] }
  }

  try {
    // Obtém o perfil do usuário
    const profile = syslic.authentication.getProfile()
    if (!profile || !profile.id) {
      throw new Error('ID do usuário não encontrado')
    }
    const response = await axios.get(
      `https://syslic.com.br/reports/RetrieveReportByYear?year=${year}&id=${profile.id}`,
      // `http://localhost:5000/Reports/RetrieveReportByYear?year=${year}`,
    )

    return response.data
  } catch (error) {
    let errorMessage = 'Erro desconhecido ao buscar dados anuais'

    if (error.response) {
      // Erro com resposta do servidor (4xx, 5xx)
      errorMessage = error.response.data?.message
      || error.response.statusText
      || `Erro ${error.response.status}`
    } else if (error.request) {
      // Requisição foi feita mas não houve resposta
      errorMessage = 'O servidor não respondeu. Verifique sua conexão.'
    } else {
      // Erro durante a configuração da requisição
      errorMessage = error.message
    }

    if (vm?.$toast) {
      vm.$toast({
        component: ToastificationContent,
        props: {
          title: 'Falha na requisição',
          text: errorMessage,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          timeout: 5000,
        },
      })
    }

    return { labels: [], datasets: [] }
  }
}

export default fetchAnnualData
